var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.252 20.1621C15.418 20.3281 15.6328 20.4258 15.8867 20.4258C16.3945 20.4258 16.7754 20.0449 16.7754 19.5371C16.7754 19.293 16.6777 19.0684 16.5215 18.9023L9.41211 11.9492L16.5215 4.99609C16.6777 4.83008 16.7754 4.5957 16.7754 4.36133C16.7754 3.85352 16.3945 3.46289 15.8867 3.46289C15.6328 3.46289 15.418 3.56055 15.252 3.72656L7.51758 11.2949C7.33203 11.4512 7.22461 11.6953 7.22461 11.9492C7.22461 12.1934 7.32227 12.418 7.50781 12.6035L15.252 20.1621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.2dbebd0868a4a2a8a4ffc8d7f7adc913.svg";
export { ForwardRef as ReactComponent };